import { removeFalsy } from "helpers/formatter";
import { logMessage } from "helpers/utils";
import {
  CardioWizardProtocol,
  FlexibilityStretch,
  PerceivedExertion,
  WorkoutPlan,
} from "models/workoutplan";
import apiService from "modules/api/apiService";
import {
  LOOKUPS_CARDIO_WIZARD_PROTOCOLS,
  LOOKUPS_FLEXIBILITY_STRETCHES_LOWER_BODY,
  LOOKUPS_FLEXIBILITY_STRETCHES_UPPER_BODY,
  LOOKUPS_PERCEIVED_EXERTION,
  WORKOUT_CARDIO_EXERCISES_LOOKUP_ACTIVITIES,
  WORKOUT_CARDIO_EXERCISES_LOOKUP_CLASSES,
  WORKOUT_CARDIO_EXERCISES_LOOKUP_CONNECTED_FITLINXX_MACHINES,
  WORKOUT_CARDIO_EXERCISES_LOOKUP_NOT_CONNECTED_FITLINXX_MACHINES,
  WORKOUT_PLAN_CRUD,
  WORKOUT_PLANS_LIST,
} from "modules/api/endpoint";
import { TPagination } from "modules/api/type";

// #region lookups
export const getLkpPerceivedExertionList = async (
  params = {}
): Promise<{
  success: boolean;
  data?: PerceivedExertion;
}> => {
  let queryParams = params
    ? Object.keys(removeFalsy(params))
        .map((key) => `${key}=${params[key]}`)
        .join("&")
    : "";

  try {
    const results = await apiService.get(
      `${LOOKUPS_PERCEIVED_EXERTION}${queryParams ? `?${queryParams}` : ""}`
    );
    return { data: results.data.payload, success: true };
  } catch (error) {
    return { success: false };
  }
};

export const getLkpFlexibilityStretchesUpperBodyList = async (
  params = {}
): Promise<{
  success: boolean;
  data?: FlexibilityStretch[];
}> => {
  let queryParams = params
    ? Object.keys(removeFalsy(params))
        .map((key) => `${key}=${params[key]}`)
        .join("&")
    : "";

  try {
    const results = await apiService.get(
      `${LOOKUPS_FLEXIBILITY_STRETCHES_UPPER_BODY}${queryParams ? `?${queryParams}` : ""}`
    );
    return { data: results.data.payload.data, success: true };
  } catch (error) {
    return { success: false };
  }
};

export const getLkpFlexibilityStretchesLowerBodyList = async (
  params = {}
): Promise<{
  success: boolean;
  data?: FlexibilityStretch[];
}> => {
  let queryParams = params
    ? Object.keys(removeFalsy(params))
        .map((key) => `${key}=${params[key]}`)
        .join("&")
    : "";

  try {
    const results = await apiService.get(
      `${LOOKUPS_FLEXIBILITY_STRETCHES_LOWER_BODY}${queryParams ? `?${queryParams}` : ""}`
    );
    return { data: results.data.payload.data, success: true };
  } catch (error) {
    return { success: false };
  }
};

export const getLkpCardioExercisesActivities = async (
  params = {}
): Promise<{
  success: boolean;
  data?: any[];
  pagination?: TPagination;
}> => {
  let queryParams = params
    ? Object.keys(removeFalsy(params))
        .map((key) => `${key}=${params[key]}`)
        .join("&")
    : "";

  try {
    const results = await apiService.get(
      `${WORKOUT_CARDIO_EXERCISES_LOOKUP_ACTIVITIES}${queryParams ? `?${queryParams}` : ""}`
    );
    return {
      data: results.data.payload.data,
      pagination: results.data.payload.pagination,
      success: true,
    };
  } catch (error) {
    return { success: false };
  }
};

export const getLkpCardioExercisesMachinesConnectedToFitlinxx = async (
  params = {}
): Promise<{
  success: boolean;
  data?: any[];
  pagination?: TPagination;
}> => {
  let queryParams = params
    ? Object.keys(removeFalsy(params))
        .map((key) => `${key}=${params[key]}`)
        .join("&")
    : "";

  try {
    const results = await apiService.get(
      `${WORKOUT_CARDIO_EXERCISES_LOOKUP_CONNECTED_FITLINXX_MACHINES}${
        queryParams ? `?${queryParams}` : ""
      }`
    );
    return {
      data: results.data.payload.data,
      pagination: results.data.payload.pagination,
      success: true,
    };
  } catch (error) {
    return { success: false };
  }
};

export const getLkpCardioExercisesMachinesNotConnectedToFitlinxx = async (
  params = {}
): Promise<{
  success: boolean;
  data?: any[];
  pagination?: TPagination;
}> => {
  let queryParams = params
    ? Object.keys(removeFalsy(params))
        .map((key) => `${key}=${params[key]}`)
        .join("&")
    : "";

  try {
    const results = await apiService.get(
      `${WORKOUT_CARDIO_EXERCISES_LOOKUP_NOT_CONNECTED_FITLINXX_MACHINES}${
        queryParams ? `?${queryParams}` : ""
      }`
    );
    return {
      data: results.data.payload.data,
      pagination: results.data.payload.pagination,
      success: true,
    };
  } catch (error) {
    return { success: false };
  }
};

export const getLkpCardioExercisesClasses = async (
  params = {}
): Promise<{
  success: boolean;
  data?: any[];
  pagination?: TPagination;
}> => {
  let queryParams = params
    ? Object.keys(removeFalsy(params))
        .map((key) => `${key}=${params[key]}`)
        .join("&")
    : "";

  try {
    const results = await apiService.get(
      `${WORKOUT_CARDIO_EXERCISES_LOOKUP_CLASSES}${queryParams ? `?${queryParams}` : ""}`
    );
    return {
      data: results.data.payload.data,
      pagination: results.data.payload.pagination,
      success: true,
    };
  } catch (error) {
    return { success: false };
  }
};

export const getLkpCardioWizardProtocolList = async (
  params = {}
): Promise<{
  success: boolean;
  data?: CardioWizardProtocol[];
}> => {
  let queryParams = params
    ? Object.keys(removeFalsy(params))
        .map((key) => `${key}=${params[key]}`)
        .join("&")
    : "";

  try {
    const results = await apiService.get(
      `${LOOKUPS_CARDIO_WIZARD_PROTOCOLS}${queryParams ? `?${queryParams}` : ""}`
    );
    return { data: results.data.payload.data, success: true };
  } catch (error) {
    return { success: false };
  }
};
// #endregion lookups

export const getWorkoutPlanList = async (
  params: any
): Promise<{
  success: boolean;
  data?: any[];
  pagination?: TPagination;
}> => {
  let queryParams = params
    ? Object.keys(removeFalsy(params))
        .map((key) => `${key}=${params[key]}`)
        .join("&")
    : "";

  try {
    const results = await apiService.get(
      `${WORKOUT_PLANS_LIST}${queryParams ? `?${queryParams}` : ""}`
    );

    return {
      data: results.data.payload.data,
      pagination: results.data.payload.pagination,
      success: true,
    };
  } catch (error) {
    return { success: false };
  }
};

export const getWorkoutPlanById = async (
  params: any
): Promise<{
  success: boolean;
  data?: WorkoutPlan;
}> => {
  let queryParams = params
    ? Object.keys(removeFalsy(params))
        .map((key) => `${key}=${params[key]}`)
        .join("&")
    : "";

  try {
    const results = await apiService.get(
      `${WORKOUT_PLAN_CRUD}${queryParams ? `?${queryParams}` : ""}`
    );

    let entry: WorkoutPlan = results.data.payload[0];
    entry.isCardioProgramIncluded =
      Array.isArray(entry.cardio_workouts) && entry.cardio_workouts.length > 0;
    entry.isFlexibilityProgramIncluded =
      Array.isArray(entry.stretch_exercises) && entry.stretch_exercises.length > 0;
    entry.isStrengthProgramIncluded =
      Array.isArray(entry.strength_workouts) && entry.strength_workouts.length > 0;

    // If we load a program from the DB then we flag it as having been saved. Once a program has
    // been saved in a workout plan it cannot be removed.
    entry.hasFlexibilityProgramBeenSaved = entry.isFlexibilityProgramIncluded;
    entry.hasCardioProgramBeenSaved = entry.isCardioProgramIncluded;
    entry.hasStrengthProgramBeenSaved = entry.isStrengthProgramIncluded;

    //Update display value for lift/drop times (they include decimal points that are not saved in db)
    if (entry.isStrengthProgramIncluded) {
      entry.strength_workouts.forEach((program) => {
        program.exercises.forEach((exercise) => {
          exercise.time_down_for_display = exercise.time_down / 100;
          exercise.time_up_for_display = exercise.time_up / 100;
        });
      });
    }

    return {
      data: entry,
      success: true,
    };
  } catch (error) {
    return { success: false };
  }
};

export const addWorkoutPlanEntry = async (
  body: any
): Promise<{
  success: boolean;
  data?: any;
  message?: string;
}> => {
  try {
    logMessage({
      member_id: 0,
      message: `WorkoutPlanServices: Adding workout plan`,
    });
    let result = await apiService.post(WORKOUT_PLAN_CRUD, body);
    return {
      data: result,
      success: true,
    };
  } catch (e) {
    return {
      message: e.message,
      success: false,
    };
  }
};

export const updateWorkoutPlanEntry = async (
  body: any
): Promise<{
  success: boolean;
  data?: any;
  message?: string;
}> => {
  try {
    logMessage({
      member_id: 0,
      message: `WorkoutPlanServices: Updating workout plan`,
    });
    let result = await apiService.put(WORKOUT_PLAN_CRUD, body);
    return {
      data: result,
      success: true,
    };
  } catch (e) {
    return {
      message: e.message,
      success: false,
    };
  }
};

export const deleteWorkoutPlanEntry = async (id: number) => {
  return apiService.del(`${WORKOUT_PLAN_CRUD}?workout_plan_id=${id}`);
};
